import React from 'react';

import withCard from './WithCard';
import PainScale from '../../../Types/Components/PainScale';

const PainScaleCard = (props) => {
  return <PainScale {...props} />
}

export default withCard(PainScaleCard);